import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import LoadingIndicator from 'components/LoadingIndicator';
import { ExportMetadataSectionBase } from './MetadataSectionBase';
import { AnonymizationLevelSectionBase } from './AnonymizationLevelSectionBase';
import { ExportMetadataForm } from './ExportMetadataForm';
import { AnonymizationLevelForm } from './AnonymizationLevelForm';
import compose from 'compose-function';
import withData from 'components/withData';

let timeoutId;
const EXPORT_PAGE_PATH = '/settings/archive';

class ExportMetadataSection extends Component {
	static propTypes = {
		editPage: PropTypes.string,
		onChange: PropTypes.func.isRequired,
		onLoad: PropTypes.func.isRequired,
		clearStaleState: PropTypes.func.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
		addAnonymizationLevelStep: PropTypes.bool,
		location: PropTypes.object.isRequired,
	};

	static defaultProps = {
		editPage: '',
	};

	componentDidMount() {
		this.props.clearStaleState();
	}

	componentDidUpdate(PrevProps) {
		const { isSaved, response, onLoad, history } = this.props;
		if (isSaved && !PrevProps.isSaved) {
			// timeout fixes 'withData' ref issue
			setTimeout(response.refetch, 0);
		}
		if (response.success !== PrevProps.response.success) {
			history.replace(EXPORT_PAGE_PATH);
			onLoad(response.data);
		}
	}

	isEmptyExportedMetadata(exportedMetadata) {
		return !Object.values(exportedMetadata).filter(x => !!x).length;
	}

	render() {
		const {
			response,
			onChange,
			history,
			editPage,
			addAnonymizationLevelStep,
			clearStaleState,
			location,
		} = this.props;

		// Used to postpone force loading after form was saved but data not yet fetched again
		const isSaved = location.pathname.lastIndexOf('/saved') > -1;
		const isMetadataPage = editPage === 'metadata';
		const isAnonymizationPage = editPage === 'anonymization';

		if (response.loading || isSaved) {
			return <LoadingIndicator loading />;
		}

		const exportedMetadata = response.success && response.data;
		const forceEdit =
			!this.props.editPage &&
			this.isEmptyExportedMetadata(exportedMetadata) &&
			!addAnonymizationLevelStep &&
			!isSaved;

		if (forceEdit) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(
				() => history.replace(`${EXPORT_PAGE_PATH}/edit/metadata`, null),
				50
			);
		}

		if (addAnonymizationLevelStep && isMetadataPage) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(
				() => history.replace(`${EXPORT_PAGE_PATH}/edit/anonymization`, true),
				50
			);
		}
		if (forceEdit || isMetadataPage) {
			return (
				<ExportMetadataForm
					exportedMetadata={exportedMetadata}
					onChange={onChange}
					forceEdit={forceEdit}
					clearStaleState={clearStaleState}
				/>
			);
		}
		if (addAnonymizationLevelStep || isAnonymizationPage) {
			return (
				<AnonymizationLevelForm
					exportedMetadata={exportedMetadata}
					onChange={onChange}
					clearStaleState={clearStaleState}
				/>
			);
		}

		return (
			<Fragment>
				<ExportMetadataSectionBase exportedMetadata={exportedMetadata} />
				<AnonymizationLevelSectionBase exportedMetadata={exportedMetadata} />
			</Fragment>
		);
	}
}

export const ExportMetadataSectionContainer = compose(
	withData('/companyMetadata')
)(ExportMetadataSection);
